import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiByocAuthentificationError extends TmApiClientError {
  public name = 'TmApiByocAuthentificationError'

  protected override code: TmTransportHttpErrorCode = 430
}
